import { tv } from "./text-value.model"

export const createPaymentMethodTV = (paymentMethods) => {
  return (paymentMethods && paymentMethods.length > 0) ? paymentMethods.map(tv(
    'payment_method_name',
    'payment_method_id'
  )) : [];
};
